export enum Target {
  _blank = "_blank",
  _parent = "_parent",
  _self = "_self",
  _top = "_top",
}

enum ValueState {
  Standard = "Standard",
  Warning = "Warning",
  Error = "Error",
  Success = "Success",
}

export default ValueState;
